module.exports = __webpack_public_path__ + "static/media/c138.a36eb4e3.jpg";